import './ui-elements'
import './form'
import './popup'
import './animation'


let current_coef=1;

Fancybox.bind("[data-fancybox]", {});
console.log(Fancybox);

if($("div").is(".js-category-slider")){ 

  var category = new Swiper('.js-category-slider', {
    spaceBetween: 10,		
    slidesPerView: 11,
    loop: true,      
    centeredSlides: true,
    allowTouchMove: false,
    breakpoints: {  
      1200: {
        slidesPerView: 9, 
        spaceBetween: 10, 
      },
      992: {
        slidesPerView: 8, 
        spaceBetween: 10, 
      },
      768: {
        slidesPerView: 5, 
        spaceBetween: 10,  
      },
      580: {
        slidesPerView: 3, 
        spaceBetween: 10, 
      },
    }, 
    // pagination: { 
    //   el: '.js-reels-pagination',
    //   clickable: true, 
    // },
    navigation: {
      nextEl: '.js-cat-next', 
      prevEl: '.js-cat-prev',
    },  

  }); 

}

function get_idarray(inputs) {	
  let temparray=new Array();	
  inputs.each(function (index, el){
    var value  = $(el).val();		
    if (value) temparray.push(value);
  });		
  return temparray; 			
}

$(window).scroll(function(){
  var aTop = 0;
  var navblock= $('header'); 
  if($(this).scrollTop()>aTop){
    navblock.addClass('fixed'); 
  } else{
    navblock.removeClass('fixed');
  }
});

$('.js-menu-btn').on('click',function(){	
  var $this = $(this);
  var navBlock = $('.menu-wrap');
  $this.toggleClass('burger_active');
  if ($this.hasClass('burger_active')) {
      navBlock.animate({"right":"0px"});	
    } else {
      navBlock.animate({"right":"-100%"});	
    } 

});


if($("div").is(".js-review-slider")){ 

  var category = new Swiper('.js-review-slider', {
    spaceBetween: 20,		
    slidesPerView: 3,
    loop: true,      
    breakpoints: {  
      992: {
        slidesPerView: 3, 
        spaceBetween: 20, 
      },
      768: {
        slidesPerView: 2, 
        spaceBetween: 20, 
      },
      600: {
        slidesPerView: 1, 
        spaceBetween: 20, 
      },
    }, 
    // pagination: { 
    //   el: '.js-reels-pagination',
    //   clickable: true, 
    // },
    navigation: {
      nextEl: '.js-review-next', 
      prevEl: '.js-review-prev',
    },  

  }); 
}

function modal_slider_init() {
  if($("div").is(".js-modalslider-slider")){ 

    var category = new Swiper('.js-modalslider-slider', {
      spaceBetween: 0,		
      slidesPerView: 1,
      loop: true,      
      navigation: {
        nextEl: '.js-modalslider-next', 
        prevEl: '.js-modalslider-prev',
      },  
  
    }); 
  }
}

if($("div").is(".js-news-slider")){ 

  var category = new Swiper('.js-news-slider', {
    spaceBetween: 20,		
    slidesPerView: 3,
    loop: true,      
    breakpoints: {  
      992: {
        slidesPerView: 3, 
        spaceBetween: 20, 
      },
      768: {
        slidesPerView: 2, 
        spaceBetween: 20, 
      },
      600: {
        slidesPerView: 1, 
        spaceBetween: 20, 
      },
    }, 
    // pagination: { 
    //   el: '.js-reels-pagination',
    //   clickable: true, 
    // },
    navigation: {
      nextEl: '.js-news-next', 
      prevEl: '.js-news-prev',
    },  

  }); 


}

$('.faq-item__header').click(function(event){			  
  event.preventDefault();   
  $(this).parent().toggleClass("opened");
}); 


if($('.home').length) {
  $(".js-anchor a").click(function (e) {
    e.preventDefault();
    if($(window).width()<=992){
      var navBlock = $('.menu-wrap');
      navBlock.animate({"right":"-100%"});	
      $('.js-menu-btn').removeClass('burger_active'); 
    }
    
  
    var _href = $(this).attr("href").split('#').pop();	
    console.log(_href);
    $("html, body").animate({
      scrollTop: ($("#"+_href).offset().top-50) + "px"
    });
    return false;
  });
} 


$("a.js-anchor").click(function () {
  var _href = $(this).attr("href");
  $("html, body").animate({
    scrollTop: ($(_href).offset().top-50) + "px"
  });
  return false;
});

$('.js-portfolio-btn').on("click",function(e){

  e.preventDefault();

  $('.js-portfolio-btn').removeClass("active");

  $(this).addClass("active");

  let data={
    'term_id': $(this).data('term_id'), 
    'action': 'portfolio_filter',
    'count': $(this).data('count'),
  };

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php',
    data: data, 
    error: function (jqXHR, exception) {
    },
    beforeSend : function ( xhr ) {		
    
    },
    success : function( data ){   
      console.log(data);
      if (data) {
        jQuery('.portfolio-items').html(data);        
      } else { }
    }
  });

});


$('.js-full-text').click(function (e) {
  e.preventDefault();
  $(this).closest('.project-content').find(".text-hidden").toggleClass("show");
  console.log($(this).text()); 
  ($(this).text() == 'Подробнее') ? $(this).text("Скрыть") : $(this).text("Подробнее"); 
});


$(window).scroll(function(){

  if($(this).scrollTop()>100){
    $(".fbanner").addClass("showing");
  } else{
    $(".fbanner").removeClass("showing"); 
  }
});

$("a.js-show-more-card").on("click",function(e){
  e.preventDefault();
  $('.servivetoogle').toggleClass("service-hidden");
});


$(".filter-category").on("click",function(e){
  e.preventDefault();
  $('.filter-category').removeClass("active");
  $(this).addClass("active");
  filter();
});



$(".filter-item  .nrooms").ionRangeSlider({

  onFinish: function (data) {
    filter();
  },
});


let price_slider;
price_slider=$(".filter-item  .price").ionRangeSlider({
  min: 0,
  max: Math.round(5000*current_coef),
  from: Math.round(5000*current_coef),
  // prettify: my_prettify,
  onFinish: function (data) {
    filter();
  },
});

// function my_prettify (n) {
//   return Math.round(n*current_coef); 
// }

function reinit_price_slider() {

//   price_slider.update({
//     from: 300,
//     to: 400
// });
  // if(price_slider)  price_slider.destroy(); 

  if(price_slider){
    price_slider.data("ionRangeSlider").update({
      min: 0,
      from: Math.round(5000*current_coef),
      max:  Math.round(5000*current_coef),
    }); 
  }


  // price_slider.max=Math.round(3000*current_coef);
  // from.Math.round(1500*current_coef);
  // price_slider.reset();

}


$(".filter-item  .length").ionRangeSlider({
  onFinish: function (data) {
    filter();
  },
  
});

$(".filter-item .capacity").ionRangeSlider({

  onFinish: function (data) {
    filter();
  },
});


var sections = $('section') 
  , nav = $('.main-menu')
  , nav_height = nav.outerHeight();
$(window).on('scroll', function () {
  var cur_pos = $(this).scrollTop();  
  sections.each(function() {
    var top = $(this).offset().top - nav_height,
        bottom = top + $(this).outerHeight();    
    if (cur_pos >= top && cur_pos <= bottom) {
      nav.find('a').parent().removeClass('active');
      sections.removeClass('active');      
      $(this).addClass('active');
      nav.find('a[href="#'+$(this).attr('id')+'"]').parent().addClass('active');
    }
  });
});





$('.js-modal-post').on("click",function(e){

  e.preventDefault();

  let blog_id=$("body").data("blog_id");

  let post_type=$(this).data("post_type");
  let post_id=$(this).data("post_id");

  let data={
    'action': 'modal_post',
    'post_type': post_type,
    'post_id': post_id,
    'blog_id': blog_id,
  };

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php',
    data: data, 
    error: function (jqXHR, exception) {
    },
    beforeSend : function ( xhr ) {		
    
    },
    success : function( data ){   

      $('.js-ajax-wrapper').html(data);

      $('.js-popup').removeClass('is-show');
      const $elem = $('.js-popup[data-block="post-modal"]');
      $elem.addClass('is-show');

      setTimeout(function(){ modal_slider_init(); set_prices(); },200)
      

    }
  });

});

$('.js-rent-yacht').on("click",function(e){
  e.preventDefault();

  let yacht_id=$(this).data("yacht_id");
  let yach_name=$(this).data("yach_name");


  $(".js-form input[name=yacht]").val(yach_name);

  $(".js-boatname").text(yach_name); 

  $(".js-form input[name=yacht_id]").val(yacht_id);

});


function filter(){
  
  let num_rooms=$("input[name=nrooms]").val();		
  
  let length=$("input[name=length]").val();		

  let price=Math.round($("input[name=price]").val()/current_coef);		

  let capacity=$("input[name=capacity]").val();		

  let yacht_category=$(".js-filter-category.active").data("term_id");		
  let yacht_type=$(".js-filter-type.active").data("term_id");		


  // let product_size=  get_idarray($('.product_size .form-checkbox__input:checked'));

  // let	order_by=$('.catalog-top a.active').data('order');	
  // let direction=$('.catalog-top a.active').attr('data-direction');	

  // order_by=$('.filter-section_order input[type="radio"]:checked').val();
  let blog_id=$("body").data("blog_id");
  let lang=$("body").data("lang");

  let data = {
    action: "productfilter",
    num_rooms: num_rooms,
    capacity: capacity,
    price:price,	
    length: length,			
    yacht_type: yacht_type,
    yacht_category: yacht_category,
    blog_id: blog_id,
    lang: lang
    // order_by: order_by,
    // direction: direction
  } 			
  console.log(data);
  $.ajax({
    url: '/wp-admin/admin-ajax.php', 
    data: data,
    type: 'POST',
    beforeSend: function(){				
    },  
    success: function(data){      
      $('.js-product-items').html(data); 
      set_prices();
    }
  });
  
}

$('.js-open-inner-modal').on("click",function(e){
  e.preventDefault();
  $("[data-block="+$(this).data("modal")+"]").toggleClass("d-none"); 
});   

$('.js-service-modal__item').on("click",function(e){
  e.preventDefault();
  $(this).toggleClass("active");
  let service_ids="";
  let service_names="";
  $(".js-selected-service").text();
  $('.js-service-modal__item.active').each(function() {
    let service_id = $(this).data('service_id');
    let service_name = $(this).find(".service-title").text();
    service_ids=service_ids+service_id+",";
    service_names=service_names+service_name+",";    
    $(".js-selected-service").text(service_names);
    $(".js-form input[name=service_ids]").val(service_ids);
  });
});

$('.js-route-modal__item').on("click",function(e){
  e.preventDefault();
   $('.js-route-modal__item').removeClass("active");
  $(this).addClass("active");
 
  let route_ids="";
  let rounte_names="";
  $(".js-selected-routs").text();
  $('.js-route-modal__item.active').each(function() {
    let route_id = $(this).data('service_id');
    let route_name = $(this).text();
    route_ids=route_ids+route_id+","; 
    rounte_names=rounte_names+route_name+",";    
    $(".js-selected-routs").text(rounte_names);
    $(".js-form input[name=route_ids]").val(route_ids);
  });
});


$(document).on('click', function(event) {
  const targetElement = $('.inner-modal, .js-open-inner-modal'); 
  if (!targetElement.is(event.target) && targetElement.has(event.target).length === 0) {
    $('.inner-modal').addClass("d-none");
  }
});



// $('.js-route-modal__item').on("click",function(e){
//   e.preventDefault();
//   $(this).toggleClass("active");
//   let route_ids="";
//   let rounte_names="";
//   $(".js-selected-routs").text();
//   $('.js-route-modal__item.active').each(function() {
//     let route_id = $(this).data('service_id');
//     let route_name = $(this).find(".service-title").text();
//     route_ids=route_ids+route_id+","; 
//     rounte_names=rounte_names+route_name+",";    
//     $(".js-selected-routs").text(rounte_names);
//     $(".js-form input[name=route_ids]").val(route_ids);
//   });
// });

$(document).on("click",".js-switch-curency",function (e) {
	e.preventDefault();  

  $(".select-item__links .btn").removeClass("btn--yellow");
	$(this).addClass("btn--yellow");
	var rate = $(this).data('rate');		
	var curency = $(this).data('curency');

  localStorage.setItem ("curency_selected",
      JSON.stringify(
      {
      'added': true,
      'curency' : curency,
      'rate' : rate
      }
		));

    set_prices();
    reinit_price_slider(); 
});



function set_prices(){
  if (typeof(localStorage) == 'undefined') {
    document.getElementById("result").innerHTML =
      'Your browser does not support HTML5 localStorage. Try upgrading.';
    } else {	
      let object = JSON.parse(localStorage.getItem("curency_selected"));    

      if(object) { 
        current_coef=object.rate;
        $('.select-item__links .js-switch-curency').removeClass('btn--yellow');
        $(".select-item__links .js-switch-curency[data-curency="+object.curency+"]").addClass("btn--yellow");

        $(".js-common-curency").text(object.curency);

        $(".js-currency").each(function(i, el) {				       
          if (object.added == true) {       
            let baseprice=$(this).find(".price-val").data("baseprice");
            $(this).find(".price-cur").text(object.curency);
            let new_price=Math.round(baseprice*object.rate);
            $(this).find(".price-val").text(new_price);
            $(".price-cur").text(object.curency);
          }        
      });
      } 
      else {
        current_coef=1;
      }
  }
}

set_prices();

reinit_price_slider();

jQuery.datetimepicker.setLocale('en');
$(".js-date").datetimepicker({ 
  format: "d/m/Y H:m",
});